export default "__VITE_ASSET__b1d3495f__"